import { createContext } from 'react';

import { AppLogo } from 'features/app_header/AppHeader';
import { screenshotContainerClass } from 'features/common/exportUtils';

export const ScreenshotChartContext = createContext(false);

export default function ScreenshotChart({ children }) {
  return (
    <ScreenshotChartContext.Provider value={true}>
      <div className={screenshotContainerClass}>
        <div className="screenshotLogoWrapper">
          <AppLogo height={18} />
        </div>
        {children}
      </div>
    </ScreenshotChartContext.Provider>
  );
}
